import { alpha, makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column',
      padding: theme.spacing(2),
      border: theme.shape.borderGray70,
      boxShadow: theme.shape.boxShadowNormal,
      borderRadius: theme.shape.borderRadiusSemiLarge,
      backgroundColor: COLORS.neutral.white,

      '&$disabled': {
        boxShadow: 'unset',
        cursor: 'default',
        '&:hover': {
          borderColor: COLORS.gray.gray70,
        },
      },

      '&$menuOpened': {
        '& $buttonMenu': {
          backgroundColor: COLORS.primary.silver,
        },
      },
      '&$selected': {
        backgroundColor: COLORS.neutral.silver,
        borderColor: COLORS.primary.default,
        '&:hover': {
          boxShadow: theme.shape.boxShadowNormal,
          borderColor: COLORS.primary.default,
        },
      },
      '&:hover': {
        borderColor: COLORS.gray.gray60,
      },
    },
    selected: {},
    menuOpened: {},
    disabled: {},
    buttonMenu: {
      padding: theme.spacing(0.5),
      '&:hover': {
        backgroundColor: COLORS.primary.silver,
      },
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    actions: {
      display: 'flex',
      columnGap: theme.spacing(0.5),
      marginLeft: 'auto',
      alignItems: 'center',
    },
    iconButton: {
      padding: theme.spacing(0.5),
      color: COLORS.gray.gray40,
      '&:hover': {
        backgroundColor: COLORS.primary.silver,
      },
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    checkbox: {
      padding: theme.spacing(0.5),
      cursor: 'pointer',
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    header: {
      display: 'flex',
      columnGap: theme.spacing(1),
      alignItems: 'center',
      marginBottom: theme.spacing(1),
      width: '100%',
    },
    avatar: {
      width: 48,
      height: 48,
    },
    name: {
      maxWidth: 208,
    },
    description: {
      marginTop: theme.spacing(0.25),
      color: COLORS.gray.gray30,
      '& span': {
        color: COLORS.gray.gray70,
      },
    },
    suggestedTag: {
      padding: theme.spacing(0.375, 0.5, 0.125),
      backgroundColor: COLORS.primary.silver,
      color: COLORS.neutral.darkGray,
    },
    painPoints: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1.5),
      width: '100%',
    },
    saveButtonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(1),
    },
    disabledOverlay: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      backgroundColor: alpha(COLORS.gray.background, 0.5),
      zIndex: 10,
    },
  }),
  { name: 'CustomerPersonaListItem' }
);
